import { useCallback, useEffect, useState } from "react";

import sseService from "@/shared/services/sseService";
import { logger } from "../loggerHelper";

type SSEMessage = unknown;

interface SSEEventSource {
  onopen: EventSource["onopen"];
  onerror: EventSource["onerror"];
}

interface SSEConnection {
  eventSource: SSEEventSource;
}

export const useSSE = (url: string | null) => {
  const [messages, setMessages] = useState<SSEMessage | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  // Initialize and manage SSE connection for the given URL
  useEffect(() => {
    if (!url) return;

    const handleMessage = (data: SSEMessage) => {
      setMessages(data);
    };

    // Connect to the SSE stream for the provided URL
    const { eventSource } = sseService.connect(url) as SSEConnection;

    // Add the listener
    sseService.addListener(url, handleMessage);

    // Set connection status based on the eventSource
    eventSource.onopen = () => {
      logger.info("\n__SSE Connected__");
      setIsConnected(true);
    };
    eventSource.onerror = (err: unknown) => {
      logger.error("\n__SSE connection error", err);
      setIsConnected(false);
    };

    return () => {
      sseService.close(url);
    };
  }, [url]);

  const close = useCallback(() => {
    sseService.close(url || "");
  }, [url]);

  return { messages, isConnected, close };
};
